import 'twin.macro';

import React from 'react';
function ContainerSkeleton({ twStyle }) {
  return <div tw='animate-pulse bg-cardcontainer rounded-2xl' css={[twStyle]}></div>;
}

export default ContainerSkeleton;
